import serveRequestErrors from "common/serve-request-errors";
import api from "services/api";

const getReminderTemplateListing = async (payload) => {
	let response = null;
	let errorMessage = null;

	try {
		const res = await api.get.reminderTemplate.option();
		const keyword = (payload?.keyword || "").toLowerCase();
		const content = res.map(({ templateName, id }) => ({ label: templateName, value: id })).filter((o) => o.label?.toLowerCase().includes(keyword));
		response = { content };
	} catch (error) {
		errorMessage = serveRequestErrors(error);
	}

	if (response) return response;

	throw errorMessage;
};

export default getReminderTemplateListing;
